import type { ChallengeStatus } from '@/api/generated';

export interface MfaPollingState {
  status: ChallengeStatus;
  isPolling: boolean;
  errorMessage: string;
  retryCount: number;
}

export interface UseMfaPollingProps {
  pollingInterval?: number;
  maxRetries?: number;
  onStatusChange?: (status: ChallengeStatus) => void;
  onError?: (error: Error) => void;
}

export interface UseMfaPollingReturn {
  state: MfaPollingState;
  startPolling: () => void;
  stopPolling: () => void;
  retry: () => void;
  resetPolling: () => void;
}

export const DEFAULT_MFA_POLLING_CONFIG = {
  pollingInterval: 2000,
  maxRetries: 30,
};
